import(/* webpackMode: "eager" */ "/app/src/app/(home)/error.tsx");
